<div class="logs-signpost-custom-waf-latency">
    <ng-content></ng-content>

    <ng-container *ngIf="trafficLogsSignpostStore.logsWafLatencySignpostData$ | async as wafLatencyPhasesData">
        <table
            class="logs-signpost-custom-waf-latency__table"
            *ngIf="(wafLatencyPhasesData | keyvalue)?.length === wafLatencyPhases.length"
        >
            <thead class="logs-signpost-custom-waf-latency__table-head">
                <tr>
                    <th class="logs-signpost-custom-waf-latency__table-head-phase"></th>
                    <th> {{ l10nKeys.latencyLabel | vtranslate}} </th>
                    <th> {{ l10nKeys.logsNumberLabel | vtranslate}} </th>
                </tr>
            </thead>
            <tbody
                class="logs-signpost-custom-waf-latency__table-body"
                *ngFor="let wafLatencyPhase of wafLatencyPhases; trackBy: trackbyIndex"
            >
                <tr *ngFor="let row of wafLatencyPhasesData[wafLatencyPhase]; index as i; trackBy: trackbyIndex">
                    <td
                        class="logs-signpost-custom-waf-latency__table-phase-cell"
                        rowspan="10"
                        *ngIf="i === 0"
                    >
                        <div class="logs-signpost-custom-waf-latency__table-phase-label">
                            {{ row.phase }}
                        </div>
                    </td>
                    <td class="logs-signpost-custom-waf-latency__table-cell">
                        <span
                            *ngIf="row.isValid && row.value !== 'NO_DATA'"
                            logFilterRange
                            [property]="row.param"
                            [start]="row.value.start"
                            [end]="row.value.end"
                            (onFilterAdd)="trafficLogsSignpostStore.closeSignpost()"
                        >
                            {{ row.value | signpostLogDataTransform: (trafficLogsSignpostStore.logSelectedSignpostConfigKey$ | async) }}
                        </span>
                        <span
                            *ngIf="row.isValid && row.value === 'NO_DATA'"
                            logFilter
                            [property]="row.param"
                            [value]="row.value"
                            (onFilterAdd)="trafficLogsSignpostStore.closeSignpost()"
                        >
                            {{ row.value }}
                        </span>
                        <span
                            *ngIf="!row.isValid"
                            logFilterableEmptyField
                            [property]="row.param"
                            (onFilterAdd)="trafficLogsSignpostStore.closeSignpost()"
                        ></span>
                    </td>
                    <td class="logs-signpost-custom-waf-latency__table-cell">
                        <div class="logs-signpost-custom-waf-latency__progress-container">
                            <div class="logs-signpost-custom-waf-latency__progress">
                                <avi-progress-bar
                                    [percentage]="row.percentage"
                                    [hidePercentage]="true"
                                ></avi-progress-bar>
                            </div>
                            <div> {{ row.count }} </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </ng-container>
</div>
<div
    class="logs-signpost-custom-waf-latency__loader clr-wrapper"
    *ngIf="trafficLogsSignpostStore.isLoading$ | async"
>
    <clr-spinner [clrMedium]="true"></clr-spinner>
</div>
